module.exports = __webpack_public_path__ + "logo.png?cbd5702bea58ad2d2b2e7385f354014c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 12
// module chunks = 0